import { useState, useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ModalContext } from '../ModalContext'
import { WhichWeightAPI } from 'WhichWeightAPI'
import { useGetCoaches } from 'redux/customHooks/useGetCoaches'
import { updateOrganizationGroupOwnerUserId } from 'redux/slices/organization'

import MediumLoadingComponent from 'components/Loading/MediumLoadingComponent'
import OutlineButton from 'components/Buttons/OutlineButton'
import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function AssignGroupOwnerModal() {

    const dispatch = useDispatch()

    const { modalData, HideModal } = useContext(ModalContext)

    const coaches = useGetCoaches()

    const organizationId = useSelector((state) => state.user.organizationId)
    const userId = useSelector((state) => state.user.id)

    const [selectedOwnerUserId, setSelectedOwnerUserId] = useState(parseInt(modalData.ownerUserId))
    const [isLoading, setIsLoading] = useState(false)
    const [errorText, setErrorText] = useState('')

    const OnSaveChanges = async () => {
        setErrorText('')
        setIsLoading(true)

        try {
            const jsonBody = {
                userId: userId,
                organizationId: organizationId,
                groupId: modalData.groupId,
                newOwnerUserId: parseInt(selectedOwnerUserId),
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('REPORTING', 'POST', '/group_owner_update', jsonBody)

            // console.log(result)

            setIsLoading(false)

            if (result.data.status === 'failure') {
                console.error(result)
                setErrorText('Failed to set group owner. Please try again.')
                return
            }

            const payload = {
                groupId: modalData.groupId,
                ownerUserId: parseInt(selectedOwnerUserId)
            }

            // console.log(payload)

            dispatch(updateOrganizationGroupOwnerUserId(payload))

            HideModal()

        } catch (error) {
            setIsLoading(false)
            console.error('Error assigning group owner:', error)
            setErrorText('Failed to set group owner. Please try again.')
            return
        }
    }

    if (coaches === null) {
        return <MediumLoadingComponent />
    }

    return (
        <div className="space-y-4">
            <div className='-mt-5 space-y-2'>
                <div className="text-left text-base font-semibold leading-6 text-gray-900">
                    Assign Owner for {modalData.groupName}
                </div>

                <p className='text-xs text-left text-gray-500'>
                    The group owner is the coach responsible for managing this group. All group data will be associated with this coach.
                </p>
            </div>

            {coaches !== null && (
                <div className='space-y-2'>
                    <p className='text-xs text-gray-800'>Current Owner</p>

                    <div className='border border-gray-400 rounded-md'>
                        <select
                            className="w-full rounded-md bg-white px-2 py-2 border-r-[10px] border-white focus:outline-none cursor-pointer hover:bg-gray-50 hover:border-gray-50"
                            value={selectedOwnerUserId}
                            onChange={(e) => setSelectedOwnerUserId(e.target.value)}
                        >
                            {coaches.map((coach) => (
                                <option key={coach.id} value={parseInt(coach.id)}>
                                    {coach.firstName} {coach.lastName} ({coach.email})
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            )}

            {errorText !== '' && (
                <div className="text-red-500 text-sm text-center">{errorText}</div>
            )}

            <div className='flex items-center gap-x-4'>
                <div className='flex-1'>
                    <OutlineButton
                        text="Cancel"
                        className='hover:bg-gray-50'
                        action={HideModal}
                    />
                </div>

                <div className='flex-1'>
                    <BrandColorButton
                        text="Save Changes"
                        action={OnSaveChanges}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </div>
    )
}
